import Vue from 'vue'
import Router from 'vue-router'
import Exchange from '@/pages/Exchange'
import Register from '@/pages/Register'
import UserProfile from '@/pages/UserProfile'
import ConfirmEmail from '@/pages/ConfirmEmail'
import RegisterStatus from '@/pages/RegisterStatus'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import SendConfirmationEmail from '@/pages/SendConfirmationEmail'
import KYC from '@/pages/KYC'
import SummaryOfKYC from '@/pages/SummaryOfKYC'
import ReferralProgram from '@/pages/ReferralProgram'
import SuitabilityTest from '@/pages/SuitabilityTest'
import KnowledgeTest from '@/pages/KnowledgeTest'
import KnowledgeTestCorrectAnswer from '@/pages/KnowledgeTestCorrectAnswer'
import Login from '@/pages/Login'
import TradeHistory from '@/pages/TradeHistory'
import AmplitudeService from '@/services/amplitude'

// Code-split
const Terms = () => import('@/pages/Terms')
const About = () => import('@/pages/About')
const Wallet = () => import('@/pages/Wallet')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Exchange',
      component: Exchange
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/register/status',
      name: 'RegisterStatus',
      component: RegisterStatus
    },
    {
      path: '/confirm-email',
      name: 'ConfirmEmail',
      component: ConfirmEmail
    },
    {
      path: '/profile',
      name: 'UserProfile',
      component: UserProfile
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/send-confirmation-email',
      name: 'SendConfirmationEmail',
      component: SendConfirmationEmail
    },
    {
      path: '/kyc',
      name: 'KYC',
      component: KYC
    },
    {
      path: '/summary-of-kyc',
      name: 'SummaryOfKYC',
      component: SummaryOfKYC
    },
    {
      path: '/referral-program',
      name: 'ReferralProgram',
      component: ReferralProgram
    },
    {
      path: '/wallet',
      name: 'Wallet',
      component: Wallet
    },
    {
      path: '/suitability-test',
      name: 'SuitabilityTest',
      component: SuitabilityTest
    },
    {
      path: '/knowledge-test',
      name: 'KnowledgeTest',
      component: KnowledgeTest
    },
    {
      path: '/knowledge-test-correct-answer',
      name: 'KnowledgeTestCorrectAnswer',
      component: KnowledgeTestCorrectAnswer
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/trade-history',
      name: 'TradeHistory',
      component: TradeHistory
    },
    // {
    //   path: '/buy',
    //   ...(ENV === 'alpha' ? {
    //     beforeEnter () {
    //       window.location.href = kulapPlusURL
    //     }
    //   } : {
    //     name: 'Buy',
    //     component: Buy
    //   })
    // },
    {
      path: '/medium',
      beforeEnter () {
        window.open('https://medium.com/kulapofficial', '_blank')
      }
    },
    {
      path: '/facebook',
      beforeEnter () {
        window.open('https://www.facebook.com/KULAP.io', '_blank')
      }
    },
    {
      path: '/youtube',
      beforeEnter () {
        window.open('https://www.youtube.com/channel/UCqiqZkXbAM8528Zs0de_frw', '_blank')
      }
    },
    {
      path: '/linkedin',
      beforeEnter () {
        window.open('https://www.linkedin.com/company/kulap/?viewAsMember=true', '_blank')
      }
    },
    {
      path: '/instagram',
      beforeEnter () {
        window.open('https://www.instagram.com/kulap.io', '_blank')
      }
    },
    {
      path: '/twitter',
      beforeEnter () {
        window.open('https://twitter.com/kulapofficial', '_blank')
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    AmplitudeService.onboardingFlow(to, from)
  }
  if (/\/#\//g.test(to.fullPath)) {
    next({ path: to.fullPath.replace('/#/', '/') })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js